var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogleSolid = function SvgGoogleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.926 8.936-13.81-7.91-.003-.002C1.784.841 1.53.777 1.339.774l11.39 11.383 3.197-3.221ZM.466 1.497c-.026.12-.042.257-.042.406v22.1c0 .217.033.405.084.56l11.38-11.56L.467 1.497Zm20.998 10.726-.008-.004-4.463-2.653-3.43 3.446 3.354 3.548 4.553-2.477c.58-.336.736-.693.736-.928 0-.236-.157-.595-.742-.932ZM1.378 25.289 12.72 13.862l3.124 3.3L2.136 25.07c-.31.136-.56.202-.758.22Z",
    fill: "currentColor"
  })));
};

export default SvgGoogleSolid;